import { ThemeProjectAquatec } from 'config/theme/project/white-labels/ThemeProjectAquatec'

export const ThemeProject = ThemeProjectAquatec;
